<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="BEP" id="_idParaDest-3"><a id="page_viii"></a><a id="page_ix">“Where guilt is, rage and courage doth abound.”</a></p><a id="page_ix">
<p class="BEPC">—BEN JONSON</p>
</a></div><a id="page_ix">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epi.vue?1d107cd4